import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi';

/**
 * API for managing office information
 */
const create = () => {
    // Create BaseApi instance with provided options
    const api = BaseApi.create({
        errorCodes: [403, 404]
    });

    const getUserSettings = (associateId) => api.get(ApiPaths.GET_USER_SETTINGS(associateId));
    const saveUserSettings = (payload) => api.put(ApiPaths.USER_SETTINGS, payload);
        
    // Return back a collection of functions
    return {
        getUserSettings, saveUserSettings
    }
}

// let's return back our create method as the default.
export default {
    create
}